import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Store } from '@ngrx/store';
import { CollegeRecrutingCenterService } from '../../services/college-recruiting-center.service';
import { MyProfileDashboardService, HelperService } from '../../services';
import { AppState, AppFields, StateList, StorageUtil } from '../../store';
import { UsStatesVectorMapComponent } from '../../shared/components/us-states-vector-map/us-states-vector-map.component';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.css']
})


export class MembersComponent implements OnInit {
  public title = "Members - Players";
  public gridTitle = "College List View";
  public playerID;
  public collegeProgramID;
  public countryID: number = 1; //United States
  //public stateID: number = [];
  public stateID: number = 0;
  public states: StateList[];
  public divisionList: any;
  public collegeConferences = [];
  public conferenceList = [];
  public collegeList = [];
  public selectedCollege;
  public collegeListCounts: number = 0;
  public collegesFormGroup: FormGroup;
  public searchButtonClicked: boolean = false;
  public itemsPerPage = 50;
  public selectedRecordsCounts: number = 0;
  public selectedRecordIndex = [];
  public collegeAndProgramIDList = [];
  public isOptionSearchClicked = true;
  public searchOpened: boolean = false;
  public openActivation: boolean = false;
  public openMerge: boolean = false;
  public confirmOpened: boolean = false;
  public clubID;
  public clubName: string = null;
  public teamName: string = null;
  public teamID;
  public isStaffEvaluations: any;
  public sendUncommittedFormGroup: FormGroup;
  years = [];
  constructor(
    private service: CollegeRecrutingCenterService,
    private tgsloaderService: Ng4LoadingSpinnerService,
    private notificationsService: NotificationsService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private dashboardService: MyProfileDashboardService,
    private router: Router,
    private helperService: HelperService,
    private store: Store<AppState>,
  ) {
    this.store.select(AppFields.App, AppFields.Club).subscribe(club => {
      if (club != null) {
        this.clubName = club.name;
      }
    });

    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      if (team != null) {
        this.teamName = team.teamName;
      }
    });
    for (let i = 2017; i <= 2040; i++) {
      this.years.push(i);
    }
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe(rs => {
      this.isStaffEvaluations = rs;
    });
  }

  ngOnInit() {
    this.playerID = 25252; // localStorage.getItem('playerID');
    this.initForm();
    this.getStatesByCountry();
    this.getCollegeDivisionAndConferenceList();
    this.getAllClubList();
    this.clubID = StorageUtil.clubID;
    this.teamID = StorageUtil.teamId;
    localStorage.setItem('CollegeBackTo', 'Colleges');
  }

  initForm() {
    this.collegesFormGroup = this.fb.group({
      SearchText: ['', [Validators.required]],
      PublicPrivate: ['', [Validators.required]],
      Division: ['', [Validators.required]],
      Conference: ['', [Validators.required]],
      EnrollMinimum: ['', [Validators.required]],
      EnrollMaximum: ['', [Validators.required]],
      TuitionMinimum: ['', [Validators.required]],
      TuitionMaximum: ['', [Validators.required]],
      CollegeSetting: ['', [Validators.required]],
      CollegeViews: ['', [Validators.required]]
    });

    this.sendUncommittedFormGroup = this.fb.group({
      FromEmail: ['', [Validators.required]]
    })
  }

  resetForm() {
    //this.router.navigate(['/college-recruiting/colleges']);
    this.collegesFormGroup.reset();
    this.desableConferenceList();
    this.searchButtonClicked = false;
    this.selectedRecordsCounts = 0;
    this.selectedRecordIndex.length = 0;

    //reset map
    this.stateID = 0;
    var obj = new UsStatesVectorMapComponent();
    obj.resetMap();
    obj.resetMultipleSelectedStateMap();
  }

  getStatesByCountry() {
    const getStateData = this.dashboardService.getStatesByCountryID(this.countryID).subscribe((rs: any) => {
      this.states = rs.data;
      getStateData.unsubscribe();
    });
  }

  getCollegeDivisionAndConferenceList() {
    this.tgsloaderService.show();
    const getDivisionData = this.service.getCollegeDivisionList().subscribe((rs: any) => {
      this.divisionList = rs;
      getDivisionData.unsubscribe();
    });

    const getConferenceData = this.service.getCollegeConferenceList().subscribe((rs: any) => {
      // this.tgsloaderService.setLoader(false);
      this.tgsloaderService.hide();
      this.collegeConferences = rs;
      this.conferenceList = rs;
      this.desableConferenceList();
      getConferenceData.unsubscribe();
    });
  }

  onDivisionChange(divisionID) {
    divisionID = divisionID[divisionID.length - 1];
    this.conferenceList = this.collegeConferences.filter((item) => item.collegedivisionID == divisionID);
    this.enableConferenceList();
  }

  desableConferenceList() {
   // this.collegesFormGroup.controls['Conference'].disable();
   // this.collegesFormGroup.controls['Conference'].setValue('');
  }

  enableConferenceList() {
    this.collegesFormGroup.controls['Conference'].enable();
    this.collegesFormGroup.controls['Conference'].setValue(this.conferenceList);
  }

  search(isOptionSearch, event) {
    event.stopPropagation();
    this.selectedRecordIndex.length = 0;
    this.selectedRecordsCounts = 0;
    var obj = {};
    if (!this.isStaffEvaluations) {
      if (isOptionSearch == 0) {
        obj = {
          StateID: this.stateID,
          //StateIDList: this.stateID,
          ClubID: this.clubID,
          TeamID: 0,
          Type: this.collegesFormGroup.value.PublicPrivate == "0" ? "Public" : this.collegesFormGroup.value.PublicPrivate == "1" ? "Private" : null,
          CollegeName: this.collegesFormGroup.value.SearchText != '' ? this.collegesFormGroup.value.SearchText : null,
          CollegeSetting: this.collegesFormGroup.value.CollegeSetting > 0 ? this.collegesFormGroup.value.CollegeSetting : 0,
          CollegeDivisionID: this.collegesFormGroup.value.Division > 0 ? this.collegesFormGroup.value.Division : 0,
          CollegeConferenceID: this.collegesFormGroup.value.Conference > 0 ? this.collegesFormGroup.value.Conference : 0,
          InState: this.collegesFormGroup.value.TuitionMinimum > 0 ? this.collegesFormGroup.value.TuitionMinimum.toString() : null,
          OutOfState: this.collegesFormGroup.value.TuitionMaximum > 0 ? this.collegesFormGroup.value.TuitionMaximum.toString() : null,
          CollegeViews: this.collegesFormGroup.value.CollegeViews,
          TeamGender: null
        };
      } else {
        obj = {
          ClubID: this.clubID,
          TeamID: 0,
          //StateIDList: [],
          StateID: null,
          Type: null,
          CollegeName: this.collegesFormGroup.value.SearchText != '' ? this.collegesFormGroup.value.SearchText : null,
          CollegeSetting: 0,
          CollegeDivisionID: 0,
          CollegeConferenceID: 0,
          InState: null,
          OutOfState: null,
          CollegeViews: null,
          TeamGender: null
        };
      }
    }
    else {
      if (isOptionSearch == 0) {
        obj = {
          //StateIDList: [],
          StateID: this.stateID,
          ClubID: 0,
          TeamID: this.teamID,
          Type: this.collegesFormGroup.value.PublicPrivate == "0" ? "Public" : this.collegesFormGroup.value.PublicPrivate == "1" ? "Private" : null,
          CollegeName: this.collegesFormGroup.value.SearchText != '' ? this.collegesFormGroup.value.SearchText : null,
          CollegeSetting: this.collegesFormGroup.value.CollegeSetting > 0 ? this.collegesFormGroup.value.CollegeSetting : 0,
          CollegeDivisionID: this.collegesFormGroup.value.Division > 0 ? this.collegesFormGroup.value.Division : 0,
          CollegeConferenceID: this.collegesFormGroup.value.Conference > 0 ? this.collegesFormGroup.value.Conference : 0,
          InState: this.collegesFormGroup.value.TuitionMinimum > 0 ? this.collegesFormGroup.value.TuitionMinimum.toString() : null,
          OutOfState: this.collegesFormGroup.value.TuitionMaximum > 0 ? this.collegesFormGroup.value.TuitionMaximum.toString() : null,
          CollegeViews: this.collegesFormGroup.value.CollegeViews,
          TeamGender: StorageUtil.teamGender
        };
      } else {
        obj = {
          ClubID: 0,
          TeamID: this.teamID,
          //StateIDList: [],
          StateID: null,
          Type: null,
          CollegeName: this.collegesFormGroup.value.SearchText != '' ? this.collegesFormGroup.value.SearchText : null,
          CollegeSetting: 0,
          CollegeDivisionID: 0,
          CollegeConferenceID: 0,
          InState: null,
          OutOfState: null,
          CollegeViews: null,
          TeamGender: StorageUtil.teamGender
        };
      }
    }



    event.target.innerHTML = 'Searching <i class="fa fa-spinner fa-spin push-5-r"></i>';
    event.target.disabled = true;

    this.service.getSearchedColleges(obj).subscribe((rs: any) => {
      event.target.disabled = false;
      event.target.innerHTML = 'Search';
      this.collegeList = rs.data;

      if (rs.data != null) {
        this.collegeListCounts = rs.data.length;
      }
      this.searchButtonClicked = true;
    }, error => {
      console.log(error);
      this.searchButtonClicked = true;
      event.target.disabled = false;
      event.target.innerHTML = 'Search';
      this.alertMessage('error', error.error);
    });
  }

  alertMessage(status, message) {
    if (status === 'success') {
      const toast = this.notificationsService.success('Success', message, {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    } else if (status === 'error') {
      const toast = this.notificationsService.error('Error', message, {
        timeOut: 4000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: false
      });
    }
  }

  getFeeInFormat(fee) {
    if (fee != null && fee != '') {
      fee = fee.split('/r').join('/');
      fee = fee.replace(/\/r/g, '');
      fee = fee.replace(/\D/g, '');
    }
    return fee;
  }

  onStateSelect(stateCode: string) {
    this.stateID = this.states.find(x => x.stateCode == stateCode.replace('US-', '')).stateID;
  }

  getSelectedRecords(collegeIDList) {
    this.selectedRecordIndex = collegeIDList;
    this.selectedRecordsCounts = this.selectedRecordIndex.length;
  }

  getCollegeAndProgramIDList(collegeAndProgramIDList) {
    this.collegeAndProgramIDList = collegeAndProgramIDList;
    //console.log("collegeAndProgramIDList =>", this.collegeAndProgramIDList);
  }

  AddToMyFavorite() {
    if (this.selectedRecordIndex.length == 0) {
      this.helperService.alertMessage('warn', 'Heads Up!', 'You  select a college to add a favorite.');
      return;
    } else if (this.selectedRecordIndex.length > 1) {
      this.helperService.alertMessage('warn', 'Heads Up!', 'You can favorite only one College at a time.');
      return;
    }

    this.collegeProgramID = this.selectedRecordIndex[0];
    this.selectedCollege = this.collegeList.find(x => x.collegeprogramID == this.selectedRecordIndex[0]);
    // this.openFlyout();
  }

  /* Add to favorite */

  openFlyout() {
    this.searchOpened = true;
  }

  closeOverlay() {
    this.searchOpened = false;
  }

  refreshPage(event) {
    this.selectedRecordIndex.length = 0;
    var obj = {};
    if (!this.isStaffEvaluations) {
      obj = {
        PlayerID: this.playerID,
        StateID: this.stateID,
        TeamID: 0,
        Type: this.collegesFormGroup.value.PublicPrivate == "0" ? "Public" : this.collegesFormGroup.value.PublicPrivate == "1" ? "Private" : null,
        CollegeName: this.collegesFormGroup.value.SearchText != '' ? this.collegesFormGroup.value.SearchText : null,
        CollegeSetting: this.collegesFormGroup.value.CollegeSetting > 0 ? this.collegesFormGroup.value.CollegeSetting : 0,
        CollegeDivisionID: this.collegesFormGroup.value.Division > 0 ? this.collegesFormGroup.value.Division : 0,
        CollegeConferenceID: this.collegesFormGroup.value.Conference > 0 ? this.collegesFormGroup.value.Conference : 0,
        InState: this.collegesFormGroup.value.TuitionMinimum > 0 ? this.collegesFormGroup.value.TuitionMinimum.toString() : null,
        OutOfState: this.collegesFormGroup.value.TuitionMaximum > 0 ? this.collegesFormGroup.value.TuitionMaximum.toString() : null,
        CollegeViews: null,
        TeamGender: null
      };
    }
    else {
      obj = {
        PlayerID: this.playerID,
        StateID: this.stateID,
        ClubID: 0,
        Type: this.collegesFormGroup.value.PublicPrivate == "0" ? "Public" : this.collegesFormGroup.value.PublicPrivate == "1" ? "Private" : null,
        CollegeName: this.collegesFormGroup.value.SearchText != '' ? this.collegesFormGroup.value.SearchText : null,
        CollegeSetting: this.collegesFormGroup.value.CollegeSetting > 0 ? this.collegesFormGroup.value.CollegeSetting : 0,
        CollegeDivisionID: this.collegesFormGroup.value.Division > 0 ? this.collegesFormGroup.value.Division : 0,
        CollegeConferenceID: this.collegesFormGroup.value.Conference > 0 ? this.collegesFormGroup.value.Conference : 0,
        InState: this.collegesFormGroup.value.TuitionMinimum > 0 ? this.collegesFormGroup.value.TuitionMinimum.toString() : null,
        OutOfState: this.collegesFormGroup.value.TuitionMaximum > 0 ? this.collegesFormGroup.value.TuitionMaximum.toString() : null,
        CollegeViews: this.collegesFormGroup.value.CollegeViews,
        TeamGender: StorageUtil.teamGender
      };
    }
    this.service.getSearchedColleges(obj).subscribe((rs: any) => {
      this.collegeList = rs.data;
      if (rs.data != null) {
        this.collegeListCounts = rs.data.length;
      }
      this.searchButtonClicked = true;
    }, error => {
      console.log(error);
      this.searchButtonClicked = true;
      this.alertMessage('error', error.error);
    });
    //this.router.navigate(['/recruiting-center/colleges']);
  }

/* END Add to favorite */

  clubList = [];
  
  getAllClubList() {
    this.tgsloaderService.show()
    this.service.getAllClubList().subscribe((rs: any) => {
      this.tgsloaderService.hide()
      this.clubList = rs;
    });
  }
  onConfirmDelete() {
    this.confirmOpened = false;
  }
    
}



// WEBPACK FOOTER //
// ./src/app/pages/members/members.component.ts